<!-- 下载产品解决方案 -->
<template>
  <div id="download">
    <div class="form">
      <div class="cover">
        <h1 v-if="page === 'download-home'">我们会在24小时内将供应链金融方案发至您的邮箱。</h1>
        <h1 v-else>请选择以下哪种行业适用于您，<br>我们会将相关的供应链金融方案发至您的邮箱。</h1>
        <portal-form :from='page' :roleType='roleType'></portal-form>
        <h3>此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。<br>有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的<a href='/pdf/tips.pdf' download="隐私声明">隐私声明</a>。</h3>
      </div>
    </div>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import Footer from './Footer'
import ModelFormVue from './ModelForm.vue'

export default {
  data () {
    return {
      page: '',
      roleType: ''
    }
  },
  created () {
    this.page = this.$route.query.page ? this.$route.query.page : 'download-home'
    this.roleType = this.$route.query.roleType
  },
  components: {
    'portal-footer': Footer,
    'portal-form': ModelFormVue
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";
@import "../css/theme-config";

#download{
  margin-top: 96px;
  background:#f2f2f2;
  .cover{
    width: 1000px;
    margin: 0 auto;
  }
  .form{
    background: #FFFFFF;
    padding: 56px 0 70px;
    h1{
      font-family:PingFangSC-Semibold;
      font-size:26px;
      color:#111111;
      letter-spacing:0.72px;
      text-align:center;
      line-height:36px;
      font-weight: normal;
      margin: 0;
    }
    h3{
      margin: 12px 0 0;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #A8ACB9;
      letter-spacing: 0.18px;
      text-align: center;
      line-height: 18px;
      font-weight: normal;
      a{
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1F5DEA;
        letter-spacing: 0.18px;
        text-align: center;
        line-height: 18px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Download.vue?497366cc